const shineSVG = (color = '#7629F2') => `
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path
    d="M0.994737 11.9364L6.49895 14.4528L8.99684 19.9979C9.32842 20.666 9.83684 21 10.5 21C11.1632 21 11.8263 20.666 12.0032 19.9979L14.5011 14.4528L20.0053 11.9364C20.6684 11.6023 21 11.0901 21 10.4221C21 9.75398 20.6684 9.0859 20.0053 8.90774L14.5011 6.3913L12.0253 0.846235C11.6937 0.33404 11.0305 0 10.5221 0C9.85895 0 9.19579 0.33404 9.01895 1.00212L6.52105 6.54719L0.994737 9.0859C0.331579 9.41994 0 9.93213 0 10.6002C0 11.2683 0.508421 11.7805 0.994737 11.9364Z" 
    fill="${color}"
/>
</svg>
`

export default shineSVG



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/shineSVG.js